import { Injectable, NgZone, ɵConsole } from '@angular/core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { SecureStorage, SecureStorageObject } from '@ionic-native/secure-storage/ngx';
import { HTTP } from '@ionic-native/http/ngx';
import { Storage } from '@ionic/storage';
import * as Constants from '../../app/app.constants';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
// Auth0 App
import Auth0Cordova from '@auth0/cordova';
import Auth0 from 'auth0-js';
// Auth0 Web
import createAuth0Client from '@auth0/auth0-spa-js';
import Auth0Client from '@auth0/auth0-spa-js/dist/typings/Auth0Client';
import { Platform } from '@ionic/angular';

const auth0ConfigMobile = {
  // needed for auth0
  clientID: environment.auth0.clientIdMobile,
  // needed for auth0cordova
  clientId: environment.auth0.clientIdMobile,
  domain: environment.auth0.domain,
  callbackURL: location.href,
  packageIdentifier: environment.auth0.packageIdentifier,
  responseType: environment.auth0.responseType,
  redirectUri: environment.auth0.redirectUri
};

//const auth0ConfigWeb: Auth0ClientOptions = {
const auth0ConfigWeb = {
    domain: environment.auth0.domain,
  client_id: environment.auth0.clientIdWeb,
  redirect_uri: environment.auth0.redirectUri,
  audience: environment.auth0.audience,
  prompt: 'login'
};

const secureStorageName = 'terre_turismo_store';
const secureStorageAuthResultKey = 'authResult';

export class AuthResult {
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
  expiresIn?: number;
  tokenType?: string;
  issueDate?: number;
  expireAt?: number;
}

@Injectable()
export class AuthService {

  auth0 = new Auth0.WebAuth(auth0ConfigMobile);
  user: any;

  public isAuth: boolean;
  private authResult: AuthResult = new AuthResult();
  private auth0Client: Auth0Client;

  constructor(public zone: NgZone, public storageService: Storage, public httpNative: HTTP, private secureStorage: SecureStorage, private httpClient: HttpClient, private platform: Platform) {

    //platform.ready().then(ready => {
      //console.log('AuthService - platform ready');
      
      if (platform.is('cordova')) {
        //console.log('AuthService - platform ready - Cordova');


        this.secureStorage.create(secureStorageName).then(
          (storage: SecureStorageObject) => {
            storage.get(secureStorageAuthResultKey).then(
              async (value: any) => {
                value = JSON.parse(value);
                if (value) {
                  this.authResult.accessToken = value.accessToken;
                  this.authResult.idToken = value.idToken;
                  this.authResult.refreshToken = value.refreshToken;
                  this.authResult.expiresIn = value.expiresIn;
                  this.authResult.tokenType = value.tokenType;
                  this.authResult.issueDate = value.issueDate;
                  this.authResult.expireAt = value.expireAt;
                  if (Date.now() > this.authResult.expireAt) {
                    this.refreshToken();
                  } else {

                    this.isAuth = true;
                  }
                } else {
                  this.authResult = null;
                  this.isAuth = false;
                }

                this.storageService.get('profile').then(value => {
                  this.user = value;
                });

              },
              error => {
                console.error(`Errore create storage: ${error}`);
              }
            );
          },
          error => {
            console.error(`Errore create storage: ${error}`);
          }
        );

      } else {
        //console.log('AuthService - platform ready - Non Cordova (web)');

        this.getAuth0Client().then(auth0Client => {

          
          auth0Client.getTokenSilently().then(
            token => {
              //console.log('Auth.Service.ts -  Costruttore - Piattaforma NON Cordova - WEB getAuth0Client - token');

              this.isAuth = true;

              this.authResult = {
                accessToken: token,
                refreshToken: 'refresh'
              };

              this.getUserProfile().then( (res: any) => {
                console.log('Auth Service - Aggiornato il profilo utente');
                this.user = res;
                /*

                this.storageService.get('profile').then(value => {
                  this.user = value;
                });
                */
              });

            },
            error => {
              this.isAuth = false;
              console.error(`Auth.Service.ts - getTokenSilently error: ${JSON.stringify(error)}`);
            }
          
          );
        }, err => {
          console.log('Auth.Service.ts -  this.getAuth0Client().then ERR');
        });
      }

    //});

    
  }



  async getAuth0Client(): Promise<Auth0Client> {
    if (!this.auth0Client) {

     // console.log('createAuth0Client before ');
      
      //this.auth0Client = await createAuth0Client(auth0ConfigWeb);
      this.auth0Client = await createAuth0Client( 
        { 
          domain: auth0ConfigWeb.domain,
          client_id: auth0ConfigWeb.client_id,
          redirect_uri: auth0ConfigWeb.redirect_uri,
          audience: auth0ConfigWeb.audience,
          prompt: 'login'
        } );


     //// console.log(`auth0CLient non c'era: ${this.auth0Client}`);

      // Provide the current value of isAuthenticated
      // this.isAuthenticatedWeb.next(await this.auth0Client.isAuthenticated());

      // Whenever isAuthenticated changes, provide the current value of `getUser`
      /*      this.isAuthenticatedWeb.subscribe(async isAuthenticated => {
        if (isAuthenticated) {
          this.profileWeb.next(await this.auth0Client.getUser());
          return;
        }

        this.profileWeb.next(null);
      }); */

      //console.log('createAuth0Client after ');

    }

    return this.auth0Client;
  }

  async handleRedirectCallback() {
    try {
      const client = await this.getAuth0Client();
      // const result = await client.handleRedirectCallback();
      const token = await client.getTokenSilently();
      this.authResult = {
        accessToken: token,
        refreshToken: 'refresh'
      };
      await this.getUserProfile();
      //
      // console.log(`authResult callback: ${JSON.stringify(this.authResult)}`);
      // return result;
    } catch (error) {
      console.error(`Errore callback: ${error}`);
    }
  }

  private setAuthResult(authResult: AuthResult): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.platform.ready().then(ready => {
        this.secureStorage.create(secureStorageName).then(
          (storage: SecureStorageObject) => {
            storage.set(secureStorageAuthResultKey, JSON.stringify(authResult));
            this.authResult = authResult;
            resolve(true);
          },
          error => {
            reject(error);
          }
        );
      });
    });
  }

  /**
   * Restituisce true se esiste un refreshToken
   */
  public isAuthenticated() {
    if (this.authResult && this.authResult.refreshToken) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Restituisce true se esiste un isEditor
   */
  public isEditor() {
    if (this.user && this.user['http://linksmt.it/roles'] && this.user['http://linksmt.it/roles'].indexOf('editor') > -1) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Restituisce un obseravble per lo stato di autenticazione
   *  20190903 - @Luca -  rimosso il setInterval, perchè faceva le chiamate ogni 3 sec e soprattutto dava l'informazione di login in ritardo
   */
  public isAuthenticatedObs() {
    return Observable.create(observer => {

      if (this.isAuthenticated()) {
        //console.log('Auth.Service.ts - isAuthenticatedObs PRE');
        observer.next(true);
      }

     // setInterval(() => {


        if (this.isAuthenticated()) {
          //console.log('Auth.Service.ts - isAuthenticatedObs - Autenticato');
          observer.next(true);

        } else {
          //console.log('Auth.Service.ts - isAuthenticatedObs - NON Autenticato');
          observer.next(false);
        }
     // }, 5000);
      
    });
  }

  public getAuthentication(): Promise<AuthResult> {
    return new Promise<AuthResult>((resolve, reject) => {

      if (this.platform.is('cordova')) {
        if (this.authResult != null && Date.now() < this.authResult.expireAt) {
          console.log('Token Valido');
          resolve(this.authResult);
        } else {

          console.log('Token NON Valido - go to RefreshToken');
          this.refreshToken().then(
            success => {
              if (success) {
                resolve(this.authResult);
              } else {
                this.logout();
                reject(`Erorre durante il refresh del token. Eseguire nuovamente il login.`);
              }
            },
            failure => {
              this.logout();
              reject(`Erorre durante il refresh del token. Eseguire nuovamente il login. Errore:${failure}`);
            }
          );
        }
      } else {

       //console.log('Platform not cordova');


        this.getAuth0Client().then(auth0Client => {
          auth0Client.getTokenSilently().then(token => {
            this.authResult = {
              accessToken: token,
              refreshToken: 'refresh'
            };
            //this.getUserProfile();
            resolve(this.authResult);
            //// console.log(`token in costruttore: ${JSON.stringify(this.authResult)}`);
          }, err => {
            console.log('getAuthentication not cordova getTokenSilently errore' );
            resolve();
          });
        }, err => {
          resolve();
        });
      }
    });
  }

  //Permetto l'autologin al massimo ogni 20 sec
  public canLogin() {
    return new Promise((resolve, reject) => {
      this.storageService.get(Constants.STORAGE_KEY_GOTOLOGIN).then(result => {
        let nowTime =  new Date().getTime();
        this.storageService.set(Constants.STORAGE_KEY_GOTOLOGIN, nowTime).then( res => {

        }, err => {
          console.error('STORAGE KO');

        });
        if (result) {       
          let secPassati = parseInt(((nowTime - result) / 1000).toFixed(0));
          if ( secPassati > 20 ) {
            resolve(true);
          } else {
             reject();
          }
        } else {
          resolve(true);
        }
      });
    });
  }

  

  public login() {
    return new Promise((resolve, reject) => {
      if (this.platform.is('cordova')) {
        console.log('LOGIN PLATFORM MOBILE');


        const client = new Auth0Cordova(auth0ConfigMobile);

        const options = {
          scope: environment.auth0.scope,
          prompt: environment.auth0.prompt,
          responseType: 'code',
          audience: environment.auth0.audience
        };

        client.authorize(options, (err: any, result: any) => {
          if (err) {
            console.log('Auth.Service.ts -  client.authorize - NON AUTORIZZATO');
            reject(err);
          }

          console.log('Auth.Service.ts -  client.authorize - AUTORIZZATO');
          // // console.log(`authResult: ${JSON.stringify(result)}`);

          const authResult: AuthResult = new AuthResult();
          authResult.idToken = result.idToken;
          authResult.accessToken = result.accessToken;
          authResult.refreshToken = result.refreshToken;
          authResult.expiresIn = result.expiresIn;
          authResult.tokenType = result.tokenType;
          authResult.issueDate = Date.now();
          authResult.expireAt = result.expiresIn * 1000 + new Date().getTime();
          // this.isAuth = Date.now() < authResult.expireAt;

          this.setAuthResult(authResult).then(
            async result => {
              await this.getUserProfile();

              console.log('Auth.Service.ts - login - this.isAuth = true Setto Auth a true');

              this.isAuth = true;
              resolve();
            },
            error => {
              console.log('Auth.Service.ts -  client.authorize setAuthResult error');
              reject(error);
            }
          );
        });

        console.log('auth service client.authorize reject');


        //reject();
      } else {
        console.log('LOGIN PLATFORM WEB');

        this.auth0Client.loginWithRedirect({
          redirect_uri: auth0ConfigWeb.redirect_uri
        });
      }
    });
  }

  public getUserProfile() {
    return new Promise((resolve, reject) => {
      this.auth0.client.userInfo(this.authResult.accessToken, (errorUserInfo: any, profile: any) => {
        if (errorUserInfo) {
          reject(errorUserInfo);
        }

        if (profile && profile.user_metadata) {
          profile.user_metadata = profile.user_metadata || {};
        }



       this.storageService.set('profile', profile).then(ready => {
          this.user = profile;

        }, err => {
          console.error('STORAGE KO');
        });

        resolve(profile);

      });
    });
  }

  private refreshToken() {
    return new Promise<Boolean>((resolve, reject) => {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

      this.httpClient
        .post(
          `https://${auth0ConfigMobile.domain}/oauth/token`,
          {
            grant_type: 'refresh_token',
            client_id: auth0ConfigMobile.clientID,
            refresh_token: this.authResult.refreshToken
          },
          {}
        )
        .subscribe(
          (result: any) => {
            // // console.log(`Refreshed: ${JSON.stringify(result)}`);
            const authResult: AuthResult = new AuthResult();
            authResult.idToken = result.id_token;
            authResult.accessToken = result.access_token;
            authResult.refreshToken = this.authResult.refreshToken;
            authResult.expiresIn = result.expires_in;
            authResult.tokenType = result.token_type;
            authResult.issueDate = Date.now();
            authResult.expireAt = result.expires_in * 1000 + new Date().getTime();
            // this.isAuth = Date.now() < authResult.expireAt;

            this.setAuthResult(authResult).then(
              async result => {

                await this.getUserProfile().then();

                this.isAuth = true;
                resolve(true);
              },
              error => {
                this.isAuth = false;
                reject(error);
              }
            );
          },
          error => {
            this.isAuth = false;
            reject(error);
          }
        );
    });
  }


  public logout() {

    return new Promise((resolve) => {

      if (this.platform.is('cordova')) {
        const logoutUrl = this.auth0.client.buildLogoutUrl({
          federated: true
        });
  
        this.httpNative
          .get(logoutUrl, {}, {})
          .then(data => {
            this.platform.ready().then(ready => {
              this.secureStorage.create(secureStorageName).then(
                (storage: SecureStorageObject) => {
                  storage.clear().then(
                    success => {
                      // // console.log(`Risultato Logout: ${JSON.stringify(data.data)}`);
                      this.storageService.remove('profile');
                      this.authResult = null;
                      this.isAuth = false;

                      resolve();
                    },
                    error => {
                      resolve();

                      console.error(`Errore logout: ${JSON.stringify(error.error)}`);
                    }
                  );
                },
                error => {
                  resolve();

                  console.error(`Errore logout: ${JSON.stringify(error.error)}`);
                }
              );
            });
          })
          .catch(error => {
            resolve();

            console.error(`Errore logout: ${JSON.stringify(error.error)}`);
          });
      } else {
        this.auth0Client.logout({
          client_id: environment.auth0.clientIdWeb,
          returnTo: environment.auth0.logoutUrl
        });

        resolve();

      }
    


    });

  }

    
}
